import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { analyzeStyle } from '../../services/apiService';
import styles from './DashboardModules.module.css';

const StylometryModule = ({ digitalLegacy, onSave }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [textSample, setTextSample] = useState('');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [error, setError] = useState(null);

  const fingerprint = digitalLegacy?.communicationStyle?.linguisticFingerprint;

  const handleAnalyze = async () => {
    if (textSample.length < 500) {
      setError(
        'Please provide at least 500 characters for an accurate analysis.'
      );
      return;
    }
    setIsAnalyzing(true);
    setError(null);
    try {
      const accessToken = await getAccessTokenSilently();
      await analyzeStyle({ text_sample: textSample }, accessToken);
      onSave();
      setTextSample('');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <div
      className={`${styles.moduleCard} ${fingerprint ? styles.completed : ''}`}
    >
      <div className={styles.moduleHeader}>
        <h5>🧬 Linguistic Fingerprint</h5>
        {fingerprint && (
          <span className={`${styles.statusTag} ${styles.complete}`}>
            Calibrated
          </span>
        )}
      </div>
      <div className={styles.moduleContent}>
        {fingerprint ? (
          <div className={styles.fingerprintDisplay}>
            <p className={styles.description}>
              Your unique writing style has been calibrated. The AI will now
              emulate this fingerprint.
            </p>
            <ul>
              {Object.entries(fingerprint).map(([key, value]) => (
                <li key={key}>
                  <strong>{key.replace(/([A-Z])/g, ' $1')}:</strong> {value}
                </li>
              ))}
            </ul>
            <button
              onClick={() => {}}
              className={`action-button secondary ${styles.editButton}`}
            >
              Recalibrate Style
            </button>
          </div>
        ) : (
          <>
            <p className={styles.description}>
              Paste in a sample of your writing (from emails, etc.) to calibrate
              the AI to your unique style.
            </p>
            <div className={styles.textareaWrapper}>
              <textarea
                rows="8"
                value={textSample}
                onChange={(e) => setTextSample(e.target.value)}
                placeholder="Paste at least 500 characters of your writing here..."
                disabled={isAnalyzing}
              />
              <span className={styles.charCounter}>
                {textSample.length} / 500
              </span>
            </div>
            {error && <p className="errorText small">{error}</p>}
            <button
              onClick={handleAnalyze}
              className="action-button primary"
              disabled={isAnalyzing || textSample.length < 500}
            >
              {isAnalyzing ? 'Analyzing...' : 'Calibrate My Style'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default StylometryModule;
